<template>
  <section class="bjzc-home-news">
    <h2 class="uk-text-center">{{ $t('sections.news') }}</h2>
    <div class="uk-container">
      <div uk-grid class="uk-grid-medium uk-child-width-1-1 uk-child-width-1-2@m uk-position-relative">
        <div v-for="item in list" :key="item.id" class="" @click="handleClick(item)">
          <div class="uk-card uk-card-default uk-grid-collapse border-radius" uk-grid>
            <div class="uk-card-media-left uk-cover-container uk-width-1-3 uk-width-1-4@m">
              <img :src="$getLocaleValue(item, 'coverUrl')" alt="" uk-cover />
              <canvas width="600" height="400"></canvas>
            </div>
            <div class="uk-width-2-3 uk-width-3-4@m">
              <div class="uk-card-body">
                <h4 class="uk-text-truncate">{{ $getLocaleValue(item, 'title') }}</h4>
                <p class="">
                  {{ $getLocaleValue(item, 'describe') }}
                </p>
                <!-- <span class="uk-visible@m">{{ item.createdAt.slice(0, 10) }}</span> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="more-btn-wrapper uk-text-center">
      <button class="bjzc-button" @click="more">{{ $t('messages.more') }}</button>
    </div>
  </section>
</template>

<script>
export default {
  name: '',
  components: {},
  data() {
    return {
      list: []
    }
  },
  created() {
    this.getList()
  },
  methods: {
    more() {
      this.$router.push({ name: 'Activity' })
    },
    getList() {
      this.$axios.get('articles', { params: { kind: 'news' } }).then(res => {
        this.list = res.data.slice(0, 4)
      })
    },
    handleClick(item) {
      this.$router.push({
        name: 'ActivityDetail',
        params: {
          id: item.id
        }
      })
    }
  }
}
</script>

<style lang="scss">
.bjzc-home-news {
  background-image: url('~@/assets/images/bg/section-4.png');
  background-position: 0% bottom;
  background-repeat: repeat-x;
  .uk-card {
    box-shadow: none;
    border: 1px solid #dcdfe6;
    cursor: pointer;

    transition: color 0.1s;
    &:hover {
      .uk-card-body h3 {
        color: $color-primary;
      }
      border-color: $color-primary;
    }
  }
  .uk-card .uk-card-body {
    padding: 1.88rem 1.25rem;
    h3 {
      font-size: 1.13rem;
      font-weight: 500;
      color: $text-normal;
      margin-bottom: 0.63rem;
    }
    p {
      font-size: 0.88rem;
      color: $text-normal;
      margin: 0;
      line-height: 1.25rem;

      display: -webkit-box;
      height: 2.5rem;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    span {
      font-size: 0.75rem;
    }
  }
}

@media (max-width: ($screen-width-s - 1)) {
  .bjzc-home-news {
    .uk-grid-margin {
      margin-top: 10px;
    }
    .uk-card .uk-card-body {
      padding: 1rem 0.75rem;
      h3 {
        font-size: 0.88rem;
        margin-bottom: 0.75rem;
      }
      p {
        font-size: 0.75rem;
      }
    }
  }
}

@media (min-width: $screen-width-m) {
  .bjzc-home-news > .uk-container > div {
    & > .uk-grid-margin {
      position: relative;
      &::before {
        content: '';
        position: absolute;
        left: 30px;
        right: 0;
        top: -15px;
        opacity: 0.5;
        border-top: 1px dashed #3d414b;
      }
    }
    &::after {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      left: 50%;
      transform: translateX(15px);
      width: 0;
      opacity: 0.5;
      border-right: 1px dashed #3d414b;
    }
  }
}
</style>
